// Phase 21 — theme provider wrapping next-themes.
//
// Why this exists: shadcn/ui's `Sonner` toaster already calls
// `useTheme()` from next-themes, but no provider was mounted. The
// homegrown toggle in Header.tsx wrote directly to
// `document.documentElement.classList` and `localStorage.prodify-theme`,
// which (a) didn't sync with React, (b) had no system-mode support,
// and (c) made first-paint logic live in a raw <script> in index.html.
//
// next-themes handles all three: SSR-safe class application, system-
// preference watching via matchMedia, and one source of truth that
// every component can `useTheme()` against.
//
// Storage key is kept compatible with the previous homegrown toggle
// (`prodify-theme`) so users who toggled before this lands keep their
// preference. New visitors get `system`.

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="prodify-theme"
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
